"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const function_1 = require("./function");
exports.default = (0, function_1.nullable)(t.string);
